'use client';

import { IconAwards } from '@/features/icons';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { cn } from '@/utils/cn';
import './style.css';
import SectionHeading from './../section-heading';
import { useLanguage } from '../../context/language-context-provider';
const KhanoumiAwards = () => {
  const {
    t,
    language
  } = useLanguage();
  const {
    isMobile
  } = useMobileDetect();
  const isEn = language === 'en';
  return <div id='awards' className='homepage-container relative flex flex-col items-center gap-7 lg:mt-25 lg:gap-16' data-sentry-component="KhanoumiAwards" data-sentry-source-file="index.tsx">
            <SectionHeading title={t('awards.title')} icon={<IconAwards />} data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx" />

            {isMobile ? <div className='grid grid-cols-2 gap-3'>
                    <div className='column'>
                        <div className={cn('item min-h-24', isEn ? 'px-2' : 'px-6')}>{t('awards.item1')}</div>
                        <div className='item min-h-30 px-2'>{t(isEn ? 'awards.item3' : 'awards.item2')}</div>
                    </div>
                    <div className='column'>
                        <div className={cn('item min-h-30', isEn ? 'px-2' : 'px-6')}>
                            {t(isEn ? 'awards.item2' : 'awards.item3')}
                        </div>
                        <div className='item min-h-24 px-2'>{t('awards.item4')}</div>
                    </div>
                </div> : <div className='grid grid-cols-4 gap-3'>
                    <div className={cn('item min-h-24', isEn ? 'px-2' : 'px-6')}>{t('awards.item2')}</div>
                    <div className='item min-h-30 px-2'>{t(isEn ? 'awards.item3' : 'awards.item4')}</div>
                    <div className={cn('item min-h-30', isEn ? 'px-2' : 'px-6')}>{t('awards.item1')}</div>
                    <div className='item min-h-24 px-2'>{t('awards.item3')}</div>
                </div>}
        </div>;
};
export default KhanoumiAwards;